<template>
	<!-- Page Introduction Wrapper -->
	<div class="page-style-a">
		<div class="container">
			<div class="page-intro">
				<h2>Your Orders</h2>
				<ul class="bread-crumb">
					<li class="has-separator">
						<i class="ion ion-md-home"></i>
						<router-link :to="{name : 'Home'}">Home</router-link>
					</li>
					<li class="is-marked">
						<a href="account.html">Orders</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- Page Introduction Wrapper /- -->
	<div class="container orders">
		<Spinner text="Getting your orders" v-if="loading" style="height: 100px" />
		<table
			class="table text-center mt-4 table-hover"
			v-if="!loading && orders.length != 0"
		>
			<thead>
				<tr>
					<th scope="col">Order No</th>
					<th scope="col">First Name</th>
					<th scope="col">Last Name</th>
					<th scope="col">Payment Status</th>
					<th scope="col">Payment Method</th>
					<th scope="col">Order Status</th>
					<th scope="col">Action</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(order, index) in orders" :key="order.id">
					<th scope="row">
						{{ order.id }}
						<Popper placement="right" :arrow="true">
							<i
								class="fa fa-info-circle"
								aria-hidden="true"
								@click="() => handlePopover(order.id)"
							></i>
							<template #content>
								<div style="width: 100px; height: 100px" v-if="orderDetails.loading">
									<Spinner />
								</div>
								<div v-else>
									<div v-for="order in selectedOrderDetails.order_details" :key="order.id">
										Product Name : {{ order.product_combination.product.product_name }}
										<small>x</small> {{ order.qty }}
										<div>Price : {{ order.total_price }}</div>
									</div>
								</div>
							</template>
						</Popper>
					</th>
					<td>{{ order.shipping_first_name }}</td>
					<td>{{ order.shipping_last_name }}</td>
					<td>{{ order.payment_status }}</td>
					<td>{{ order.payment_method }}</td>
					<td>{{ order.order_status }}</td>
					<td @click="() => handleTableRowClick(order.id)">View Details</td>
				</tr>
			</tbody>
		</table>
		<!-- PAGINATION LOGIC FOR BETA -->
		<!-- <ul style="display: flex">
      {{Math.ceil(total/limit)}}
      <li v-for="index in Math.ceil(total / limit)" :key="index" class="p-3">
        <router-link :to="{ name: 'Orders', query: { page: index } }">{{
          index
        }}</router-link>
      </li>
    </ul> -->
		<Spinner v-if="pagination_loading" style="height: 100px" />
		<div
			v-if="
				!loading &&
				!pagination_loading &&
				last_page != current_page &&
				orders.length != 0
			"
			class="redirect-link-wrapper text-center u-s-p-t-25 u-s-p-b-80"
			style="width: 100%"
		>
			<a class="redirect-link" href="#" @click.prevent="loadMoreOrders"
				>View more orders</a
			>
		</div>
		<div
			v-if="
				!loading &&
				!pagination_loading &&
				last_page == current_page &&
				orders.length != 0
			"
			class="redirect-link-wrapper text-center u-s-p-t-25 u-s-p-b-80"
			style="width: 100%"
		>
			<a class="redirect-link">No more orders</a>
		</div>
	</div>
	<div class="product-not-found" v-if="!loading && orders.length == 0">
		<div class="not-found">
			<h2>SORRY!</h2>
			<h6>You Don't Have Any Orders.</h6>
		</div>
	</div>
	<Footer />
</template>

<script>
	import axios from "axios";
	import Footer from "../components/Bottom/Footer.vue";
	import Spinner from "../components/Loaders/Spinner.vue";
	import Popper from "vue3-popper";
	export default {
		components: {Footer, Spinner, Popper},
		data() {
			return {
				token: localStorage.getItem("token"),
				orders: [],
				loading: true,
				last_page: 0,
				current_page: 1,
				pagination_loading: false,
				total: 0,
				limit: 0,
				orderDetails: {
					data: [],
					loading: false,
				},
				selectedOrderDetails: "",
			};
		},

		methods: {
			scroll() {
				const el = document.getElementsByClassName("container")[0];
				this.$smoothScroll({
					scrollTo: el, // scrollTo is also allowed to be number
					offset: 200,
				});
			},
			async fetchOrders(type) {
				this.setLoading(type, true);
				let url = process.env.VUE_APP_API_URL + "/api/frontend/user-orders";
				url = url + `?page=${this.current_page}`;
				try {
					let {data} = await axios.post(url, null, {
						headers: {
							Authorization: `Bearer ${this.token}`,
						},
					});
					this.orders.push(...data.payload.data);
					this.last_page = data.payload.last_page;
					this.total = data.payload.total;
					this.limit = data.payload.per_page;
					this.setLoading(type, false);
				} catch (error) {
					console.log(error);
					this.setLoading(type, false);
				}
			},

			async fetchOrdersDetails(order_id) {
				this.orderDetails.loading = true;
				let url = process.env.VUE_APP_API_URL + "/api/frontend/order-detail";
				try {
					let {data} = await axios.post(
						url,
						{order_id},
						{
							headers: {
								Authorization: `Bearer ${this.token}`,
							},
						}
					);
					console.log(data.payload);
					this.orderDetails.data.push(data.payload);
					this.selectedOrderDetails = data.payload;
					this.orderDetails.loading = false;
				} catch (error) {
					console.log(error);
					this.orderDetails.loading = false;
				}
			},

			handleTableRowClick(id) {
				this.$router.push({name: "OrderDetails", params: {id: id}});
			},
			loadMoreOrders() {
				this.current_page = this.current_page + 1;
				this.fetchOrders("page");
			},

			handlePopover(order_id) {
				const orderDetail = this.orderDetails.data.find(
					(order) => order.id == order_id
				);
				if (orderDetail) {
					this.selectedOrderDetails = orderDetail;
					return;
				}
				this.fetchOrdersDetails(order_id);
			},

			setLoading(type, status) {
				if (type == "intial") {
					this.loading = status;
				} else if (type == "page") {
					this.pagination_loading = status;
				}
			},
		},
		mounted() {
			console.log("Orders Mounted");
			this.fetchOrders("intial");
			this.scroll();
		},
	};
</script>

<style scoped>
	tr {
		cursor: pointer;
	}
	* {
		--popper-theme-background-color: #ffffff;
		--popper-theme-background-color-hover: #ffffff;
		--popper-theme-text-color: #333333;
		--popper-theme-border-width: 1px;
		--popper-theme-border-style: solid;
		--popper-theme-border-color: #eeeeee;
		--popper-theme-border-radius: 6px;
		--popper-theme-padding: 32px;
		--popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
	}
</style>
